<script lang="ts">
  import { onMount, type Snippet } from 'svelte';
  import { Offcanvas } from 'bootstrap';

  interface Props {
    appTitle: string;
    children: Snippet;
  }

  let { appTitle, children }: Props = $props();
  const breakpoint = 'md';

  let offcanvasElement: HTMLDivElement;
  let bsOffCanvas: Offcanvas;

  onMount(() => {
    bsOffCanvas = new Offcanvas(offcanvasElement);
  });
</script>

<nav class="navbar navbar-expand-{breakpoint}">
  <div class="container-fluid px-0">
    <ul class="navbar-nav d-none d-{breakpoint}-flex">
      {@render children()}
    </ul>
  </div>
</nav>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar" bind:this={offcanvasElement}>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">{appTitle}</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close Drawer Navigation"
      onclick={() => {
        bsOffCanvas.hide();
      }}
    ></button>
  </div>
  <!-- all the click events inside the offcanvas body should trigger the drawer to close -->
  <!-- svelte-ignore a11y_no_static_element_interactions, a11y_click_events_have_key_events -->
  <div
    class="offcanvas-body"
    onclick={() => {
      bsOffCanvas.hide();
    }}
  >
    <ul class="navbar-nav">
      {@render children()}
    </ul>
  </div>
</div>

<style>
  .navbar-nav {
    --bs-nav-pills-link-active-bg: var(--uams-primary-red);
    --bs-nav-link-color: var(--uams-primary-red);
    --bs-nav-link-hover-color: var(--uams-primary-red-hover);
    --bs-nav-link-font-weight: 400;
  }

  .navbar {
    --bs-navbar-padding-y: 0;
    --bs-navbar-padding-x: 1.5rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    border-top: 2px solid #f0eeef;
  }

  .navbar-nav {
    --bs-nav-link-padding-y: 1.125rem;
    --bs-nav-link-padding-x: 0.75rem;
    --bs-nav-link-font-size: 1.25rem;
  }

  .offcanvas-body {
    /* reset bootstrap padding because we want the borders of nav items and background of submenus to extend edge-to-edge */
    padding-left: 0;
    padding-right: 0;

    /* reset bootstrap padding because there is too much spacing between header and menu */
    padding-top: 0;
  }
</style>
